import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';

const VotingGame = ({ config, onEnd }) => {
    const [votesA, setVotesA] = useState(0);
    const [votesB, setVotesB] = useState(0);
    const [round, setRound] = useState(0);

    const [questions] = useState(() =>
        config.questions ? [...config.questions].sort(() => 0.5 - Math.random()).slice(0, 10) : []
    );

    if (questions.length === 0) return <div className="game-loading">Chargement...</div>;

    const currentQ = questions[round];
    const isFinished = round >= questions.length;

    const handleVote = (option) => {
        if (option === 'A') setVotesA(votesA + 1);
        if (option === 'B') setVotesB(votesB + 1);
    };

    const nextRound = () => {
        setVotesA(0);
        setVotesB(0);
        if (round + 1 < questions.length) {
            setRound(round + 1);
        } else {
            onEnd(0);
        }
    };

    if (isFinished) return null;

    const total = votesA + votesB;
    const percentA = total === 0 ? 50 : (votesA / total) * 100;
    const percentB = total === 0 ? 50 : (votesB / total) * 100;

    return (
        <div className="voting-container">
            <h2 className="voting-question">
                {currentQ.question || "Que préférez-vous ?"}
            </h2>

            <div className="voting-options-row">
                {/* OPTION A */}
                <div className="voting-block">
                    <button onClick={() => handleVote('A')} className="btn-vote vote-a">
                        {currentQ.imageA && <img src={currentQ.imageA} alt="A" className="vote-img" />}
                        <span className="vote-label">{currentQ.optionA}</span>
                    </button>
                    <div className="vote-counter counter-a">{votesA}</div>
                </div>

                {/* OPTION B */}
                <div className="voting-block">
                    <button onClick={() => handleVote('B')} className="btn-vote vote-b">
                        {currentQ.imageB && <img src={currentQ.imageB} alt="B" className="vote-img" />}
                        <span className="vote-label">{currentQ.optionB}</span>
                    </button>
                    <div className="vote-counter counter-b">{votesB}</div>
                </div>
            </div>

            <div className="voting-gauge-bg">
                <div className="gauge-fill-a" style={{ width: `${percentA}%` }}></div>
                <div className="gauge-fill-b" style={{ width: `${percentB}%` }}></div>
            </div>

            <button onClick={nextRound} className="btn-next-vote">
                Question Suivante <ChevronRight />
            </button>
        </div>
    );
};

export default VotingGame;